import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect, useState } from 'react';
import PageBanner from '../Components/Other/PageBanner'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import { CommonApiFun } from '../Redux/Action/index'
import { routes } from '../MainPage'
import { useNavigate } from "react-router-dom";
function Gellary(props) {
    const dispatch = useDispatch()
    let navigate = useNavigate();
    var blogArr = useSelector((state) => state.galleryArr)
    const [isLoading, setIsloading] = useState(true)
    const [isShow, setIsShow] = useState({ show: false, images: [], CurrentIndex: 0 })
    const { show, images, CurrentIndex } = isShow
    useEffect(() => {
        var data = { action: "gallery" }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
            dispatch({ type: 'GALLERY_DATA', payload: res.data })
            setIsloading(false)
        }).catch((e) => {

        })
    }, [])
    var image1 = [
        require('../img/emptyData.png'), require('../img/banner_xs_2.png'), require('../img/banner_xs_3.png'),
    ]
    var image2 = [
        require('../img/banner_xs_4.png'), require('../img/banner_xs_5.png'), require('../img/banner_xs_1.png'),
    ]
    var image3 = [
        require('../img/diet_plan.jpeg'), require('../img/deafness.png'), require('../img/banner3.png'), require('../img/banner4.png'), require('../img/banner5.png')
    ]
    //banner1
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Gallery"}></PageBanner>
                <div className="MainContent gallery_box">
                    <div className="container">
                        <div className="row news-wrapper article-grid">
                            <div className="news_wrap">
                                <div className="news_box">
                                    {(blogArr.length == 0 && isLoading) ? <div className='loader-box'><div className="loader"></div></div>
                                        : blogArr.length == 0 &&
                                        <div class="not_found">
                                            <span><img src={require('../img/emptyData.png')} /></span><p>No article Found</p>
                                        </div>}
                                        {
                                        blogArr.map((item, index) => {
                                        
                                            return (
                                                <div className="col-mb-12 col-xs-6 col-4 article-item" key={index}>
                                                    <div className="news_inner" onClick={() => {
                                                        document.body.classList.add('modal-open');
                                                        setIsShow({ show: true, images: item.images.split(","), CurrentIndex: 0 })
                                                    }}>
                                                        <a href="javascript:void(0)">
                                                            <img src={(item.images.split(","))[0]} />
                                                        </a>
                                                        <div class="gallery_detail">
                                                            <h5>
                                                                <a href="javascript:void(0)">
                                                                    {item.title}
                                                                </a>
                                                            </h5>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        }
                                        )
                                    }
                               
                                    <section id="gallery" className={show ? `gallery_show` : ''} >
                                        <div id="overlay" style={{}}>
                                            <div className='overlay_box'>
                                                <div id="prevButton" onClick={() => setIsShow((prev) => ({ ...prev, CurrentIndex: CurrentIndex == 0 ? images.length - 1 : CurrentIndex - 1 }))}>
                                                    <i className="fa fa-chevron-left" />
                                                </div>
                                                <div className='overlay_imgBox'>
                                                    {<img src={isShow.images[CurrentIndex]} />}
                                                </div>
                                                <div id="nextButton" onClick={() =>
                                                    setIsShow((prev) => ({ ...prev, CurrentIndex: (images.length - 1) == CurrentIndex ? 0 : CurrentIndex + 1 }))}
                                                >
                                                    <i className="fa fa-chevron-right" />
                                                </div>
                                                <div id="exitButton" onClick={() => {
                                                    document.body.classList.remove('modal-open');
                                                    setIsShow({ show: false, images: [], CurrentIndex: 0 })
                                                }
                                                }>
                                                    <i className="fa fa-times" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='gallary_overlay' onClick={(e) => {
                                            document.body.classList.remove('modal-open');
                                            setIsShow({ show: false, images: [], CurrentIndex: 0 })
                                        }}></div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </PageWrapper>
    );
}

export default Gellary;